export default "__VITE_ASSET__BZlwH2QQ__"